import axios from 'axios';
import {
    BASE_URL_SERVICE,
} from '../constants'

/* -------------------------------------------------------------------------- */
/*                               Get Comerciales                              */
/* -------------------------------------------------------------------------- */
export async function getComerciales({ usuario_id }) {
    try {
        var config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'content-type': 'text/json',
                'Authorization': "04871209347109238740"
            }
        };

        const response = await axios.get(BASE_URL_SERVICE + 'comerciales', {
            params: {
                usuario_id,
            }
        }, config);

        return response.data;
    } catch (error) {
        return undefined;
        // throw error;
    }

}

/* -------------------------------------------------------------------------- */
/*                      actualizarActividadComercial                          */
/* -------------------------------------------------------------------------- */
export async function actualizarActidadComercial({usuario_id}) {
    try {
        let formData = new FormData();

        formData.append("usuario_id", usuario_id);
        // formData.append("alumno_id", alumno_id);

        const response = await axios({
            method: 'post',
            url: BASE_URL_SERVICE + 'comerciales/actualizar_actividad_comercial',
            data: formData,
            headers: {
             // 'Content-Type': 'multipart/form-data',
             // 'Authorization': "Bearer eyJ0eciOiJSUzI1NiJ9.eyJMiIsInNjb3BlcyI6W119.K3lW1STQhMdxfAxn00E4WWFA3uN3iIA", 
             // 'X-AUTH-TOKEN': "1231231231231231"
            },
     //   crossorigin: true,    
     //   mode: 'no-cors',      
         });

        return response.data;
    } catch (error) {
        return undefined;
        // throw error;
    }

}